module.exports = __webpack_public_path__ + "img/56.0e4bf414.png";